import { Link } from 'react-router-dom'
import Divider from '../../../components/Divider'
import useResize from '../../../hooks/useResize'
import { VIEWPORT_LG } from '../../../utils/constants'
import DashboardWrapper from '../../Dashboard/components/DashboardWrapper'
import hutrit_club_icon from '../icons/already_hutrit_club_member_company.svg'
import { PRIVATE_ROUTES } from '../../../Routes/routes'
import { useQuery } from '@tanstack/react-query'
import { listOfChallenges } from '../../../services/HutritClub'
import Loader from '../../../components/Loader'
import ChallengeCard from '../ChallengeCard/ChallengeCard'

const ListOfChallenges = () => {
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG

  const { data: listOfChallengesData, isLoading: isLoadingListOfChallenges } =
    useQuery(['list-of-challenges'], listOfChallenges)

  return (
    <DashboardWrapper dashboardWrapperClassName="w-100 pt-5 mt-5">
      <header className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-4">
          <h1 className="text-on-bg-primary fw-bolder">Retos</h1>{' '}
          <img src={hutrit_club_icon} width={isMobile ? 150 : 150} />
        </div>
      </header>
      <div className="d-flex align-items-center justify-content-end">
        <Link
          className="p-3 btn-bg-CTA-primary text-on-bg-primary btn"
          to={PRIVATE_ROUTES.create_challenge}
        >
          Crear nuevo reto
        </Link>
      </div>
      <Divider className="w-100 bg-on-bg-primary mb-1 mt-4 d-none d-lg-flex" />
      {isLoadingListOfChallenges ? (
        <Loader />
      ) : (
        <div className='tm-talent-container gap-3 mt-3'>
          {listOfChallengesData?.list?.map((props) => {
            return <ChallengeCard key={props.id} {...props} />
          })}
        </div>
      )}
    </DashboardWrapper>
  )
}

export default ListOfChallenges
